import { useMutation } from '@tanstack/react-query';
import { setUserProfile, type SetUserProfileBody } from 'api/set-user-profile';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { useInvalidateUserProfile } from 'hooks/queries/use-invalidate-user-profile.hook';

type SetUserProfileRequest = {
  body?: SetUserProfileBody;
};

export const useSetUserProfile = () => {
  const { systemId } = usePatientPortalContext();
  const invalidateUserProfile = useInvalidateUserProfile();

  return useMutation({
    mutationFn: ({ body = {} }: SetUserProfileRequest) =>
      setUserProfile(systemId, body),
    onSuccess: invalidateUserProfile,
  });
};
